"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableLocalesByRegion = exports.defaultLocaleByRegion = exports.RegulatoryRegion = exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["DE_DE"] = "de";
    Locale["EN_DE"] = "en";
    Locale["EN_GB"] = "en-GB";
    Locale["EN_CA"] = "en-CA";
})(Locale || (exports.Locale = Locale = {}));
var RegulatoryRegion;
(function (RegulatoryRegion) {
    RegulatoryRegion["DACH"] = "DACH";
    RegulatoryRegion["UK"] = "UK";
    RegulatoryRegion["CANADA"] = "CANADA";
})(RegulatoryRegion || (exports.RegulatoryRegion = RegulatoryRegion = {}));
exports.defaultLocaleByRegion = (_a = {},
    _a[RegulatoryRegion.DACH] = Locale.DE_DE,
    _a[RegulatoryRegion.UK] = Locale.EN_GB,
    _a[RegulatoryRegion.CANADA] = Locale.EN_CA,
    _a);
exports.availableLocalesByRegion = (_b = {},
    _b[RegulatoryRegion.DACH] = [Locale.DE_DE, Locale.EN_DE],
    _b[RegulatoryRegion.UK] = [Locale.EN_GB],
    _b[RegulatoryRegion.CANADA] = [Locale.EN_CA],
    _b);
